import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Post from "./post";
import {isPast} from "../../system/utils";
import ChatMessage from "../chat-message/chat-message";
import PostCategory from "../post-category/post-category";

export function usePost() {
    const [loading, setLoading] = useState(false);
    const {user} = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const getPosts = async (status=["published"])=>{
        try {
            const post = new Post();
            const query = {
                filters: {
                    $and:[
                        { publicationStatus: { $in: status}}
                    ],
                },
                populate:{
                    post_category:true,
                    previous_post:true,
                    next_post:true
                }
            }
            const _data = await post.getAll(query);

            return _data.data
        }catch (e){

        }
    }
    const getPost = async (documentId)=>{
        try {
            const post = new Post();
            const query = {
                filters: {
                    $and:[
                        { publicationStatus: { $eq: "published"}}
                    ],
                },
                populate:{
                    post_category:true,
                    previous_post:true,
                    next_post:true
                }
            }
            const _data = await post.getById(documentId, query);

            return _data.data
        }catch (e){

        }
    }

    const updatePost = async (postId, postData)=>{
        try {
            const post = new Post();
            const query = {
                populate:{
                    post_category:true,
                    previous_post:true,
                    next_post:true
                }
            }
            const _data = await post.update(postId, postData, query);
            return _data.data
        }catch (e){

        }
    }

    const createPost = async (postData)=>{

        try {
            const post = new Post();
            const query = {
                populate:{
                    post_category:true,
                    previous_post:true,
                    next_post:true
                }
            }
            const _data = await post.create(postData, query);
            return _data.data
        }catch (e){

        }
    }

    const deletePost = async (documentId)=>{
        try {
            const post = new Post();
            const _data = await post.delete(documentId);
            return _data.data
        }catch (e){

        }
    }

    return {getPost, getPosts, createPost, updatePost, deletePost};
}
